export const publicationData = {
  data: [
    {
      id: 1,
      is_fixed: true,
      comment:
        'El Ministerio de Trabajo y Promocién del Empleo hace de conocimiento que en\n' +
        '          redes sociales esta circulando una imagen sobre un supuesto comunicado que\n' +
        '          declararia el jueves 21 de junio de 2018 como dia no laborable a nivel nacional.\n' +
        '          En tal sentido, es preciso indicar que se trata de una imagen falsa, por lo que\n' +
        '          invocamos a empleadores y trabajadores a no dejarse sorprender.',
      attachments_url: [
        'https://images.pexels.com/photos/261679/pexels-photo-261679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        'https://images.pexels.com/photos/357514/pexels-photo-357514.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      ],
      attachments_type: 'IMAGE',
      status: 'PUBLISHED',
      author: {
        id: 2706,
        picture: 'https://i.pravatar.cc/100',
        lastname: 'Cordoba',
        firstname: 'Alejandro',
        nickname: 'alejandrocordoba',
      },
      stats: {
        answers: 2,
        reactions: 22,
      },
      last_reactions: ['PROUD', 'LIKE', 'EXCELLENT'],
      user_reaction: 'LOVE',
      created_at: '2020-10-12T22:49:01.331314Z',
      updated_at: '2021-03-18T11:00:57.840147Z',
    },
    {
      id: 2,
      is_fixed: false,
      comment: 'Publicacion con attachments PDF',
      attachments_url: [
        'https://pepa.holla.cz/wp-content/uploads/2016/10/Go-in-Action.pdf',
      ],
      attachments_type: 'PDF',
      status: 'PUBLISHED',
      author: {
        id: 2706,
        picture: 'https://i.pravatar.cc/100',
        lastname: 'Rodriguez',
        firstname: 'Alejandro',
        nickname: 'alejo',
      },
      stats: {
        answers: 2,
        reactions: 22,
      },
      last_reactions: ['PROUD', 'LIKE', 'LOVE'],
      user_reaction: 'INSPIRING',
      created_at: '2020-10-12T22:49:01.331314Z',
      updated_at: '2021-03-18T11:00:57.840147Z',
    },
    {
      id: 3,
      is_fixed: false,
      comment: 'Publicacion con attachments PDF',
      attachments_url: [
        'https://pepa.holla.cz/wp-content/uploads/2016/10/Go-in-Action.pdf',
        'https://pepa.holla.cz/wp-content/uploads/2016/10/Go-in-Action.pdf',
      ],
      attachments_type: 'PDF',
      status: 'PUBLISHED',
      author: {
        id: 2706,
        picture: 'https://i.pravatar.cc/100',
        lastname: 'Rodriguez',
        firstname: 'Alejandro',
        nickname: 'alejo',
      },
      stats: {
        answers: 0,
        reactions: 22,
      },
      last_reactions: ['PROUD', 'LIKE', 'LOVE'],
      user_reaction: 'INSPIRING',
      created_at: '2020-10-12T22:49:01.331314Z',
      updated_at: '2021-03-18T11:00:57.840147Z',
    },
  ],
  messages: [
    {
      type: 'OK',
      code: 'OK',
      message: 'Ok',
      href: '',
    },
  ],
  errors: null,
}
